exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".date-picker-parent-container>div{width:calc(50% - 5px);margin-right:10px}.date-picker-parent-container>div:last-child{margin-right:0}.date-picker-container>div{display:flex;height:36px}.date-picker-container>div>input{height:34px}.rw-calendar{width:255px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/Modules/DateRangeContainer/DateRangeContainer.less
 ** module id = 1059
 ** module chunks = 0
 **/